export const SIGNATURE_TYPE_OPTIONS = [
  {
    value: 'pep',
    label: 'ПЭП',
  },
  {
    value: 'unep',
    label: 'УНЭП/УКЭП',
  },
];

export const WITH_ORDER_OPTIONS = [
  {
    value: 'true',
    label: 'Да',
  },
  {
    value: 'false',
    label: 'Нет',
  },
];

export const KONTUR_UNAVAILABLE_LINKS = [
  {
    href: window.REACT_APP_VKHRTEK_STATUS_PAGE_LINK,
    name: 'Статус восстановления сервиса',
  },
  {
    href: window.REACT_APP_VKHRTEK_ABOUT_GOSKEY_LINK,
    name: 'Подробнее об УНЭП Госключ',
  },
];

export const MAX_LEVEL_WITH_CHILDREN = 0;

export const LEVEL_OFFSET_WITH_ICON = ['0', '24', '48'] as const;
export const LEVEL_OFFSET_WITHOUT_ICON = ['24', '48', '72'] as const;

export const MAX_NAME_LENGTH = 256;

export const NOT_EMPTY_OPTIONS = {
  message: 'Обязательное поле',
};
